import React from 'react';
import { useTranslation } from 'react-i18next';
import { PapiDeviation } from '@wix/da-papi-types';
import { sanitizeHref } from '@wix/da-url';
import TextButton from '@wix/da-ds/pkg/Buttons/TextButton/TextButton';
import { getDeviationUrl } from '../../../../DeviationViews/_helpers';
import DeviationDumbView from '../../../../DeviationViews/Dumbo';
import DeviationLink from '../../../../Duperbrowse/DeviationLink/DeviationLink';

import s from './CompletedOrdersThumbs.scss';

// we only show thumbs if there's at least 2 completed orders, and a max of 3
const MIN_ORDERS_THUMBS = 2;
const MAX_ORDERS_THUMBS = 3;

interface Props {
  parentDeviation: PapiDeviation;
  deviations: PapiDeviation[];
  hasMoreDeviations?: boolean;
}

const CompletedOrdersThumbs: React.FC<Props> = ({
  parentDeviation,
  deviations,
  hasMoreDeviations,
}) => {
  const { t } = useTranslation();
  const showSeeMoreButton =
    deviations.length > MAX_ORDERS_THUMBS || hasMoreDeviations;

  if (deviations.length < MIN_ORDERS_THUMBS) {
    return null;
  }

  return (
    <div className={s['root']}>
      <div className={s['header']}>
        {t('shop.card.originals.completedOrders')}
        {showSeeMoreButton && (
          <TextButton
            size="small"
            variant="main"
            priority="secondary"
            href={sanitizeHref(sanitizeHref(getDeviationUrl(parentDeviation)))}
          >
            {t('shop.card.originals.seeMore')}
          </TextButton>
        )}
      </div>
      <div className={s['thumbs']}>
        {deviations.slice(0, MAX_ORDERS_THUMBS).map(orderDeviation => (
          <DeviationLink
            className={s['thumb']}
            deviation={orderDeviation}
            key={orderDeviation.deviationId}
          >
            <DeviationDumbView
              key={orderDeviation.deviationId}
              deviation={orderDeviation}
              width={113}
              height={65}
            />
          </DeviationLink>
        ))}
      </div>
    </div>
  );
};
CompletedOrdersThumbs.displayName = 'CompletedOrdersThumbs';

export default CompletedOrdersThumbs;
